export function resolveApiBaseUrl({
  hostname = "",
  reactAppApiBase,
} = {}) {
  const override = String(reactAppApiBase || "").trim();
  if (override) {
    return override.replace(/\/$/, "");
  }

  const host = String(hostname || "").toLowerCase();
  if (host === "localhost" || host === "127.0.0.1") {
    return "http://localhost:8000";
  }

  return "https://writeflow-tutor-na35.onrender.com";
}

const resolvedApiBaseUrl =
  resolveApiBaseUrl({
    hostname: typeof window !== "undefined" ? window.location.hostname : "",
    reactAppApiBase: typeof process !== "undefined" ? process.env?.REACT_APP_API_BASE_URL : "",
  });

export const API_BASE_URL = String(resolvedApiBaseUrl).replace(/\/$/, "");

if (typeof process !== "undefined" && process.env?.NODE_ENV === "development") {
  console.log("[writeflow] API_BASE_URL =", API_BASE_URL);
}
